export default __webpack_public_path__ + "static/media/aboutslider3.735c451b.webp";